import { Navigate, useLocation } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const StudentPrivateRouter = ({children}) => {
    const token = localStorage.getItem('jwt')
    const location = useLocation()
    let token_decode = null
    if (token && token !== 'undefined'){
        token_decode = jwtDecode(token)
        if (token_decode.rol === 'student'){
            if (token_decode.mustChangePassword && location.pathname !== '/student/change-password') {
                return <Navigate to="/student/change-password" replace />
            }
            return children
        } else if (token_decode.rol === 'parent') {
            const target = location.pathname.replace(/^\/student/, '/parent')
            return <Navigate to={target} replace />
        } else {
            return <Navigate to="/" replace />
        }
    }
    return <Navigate to="/" replace />
}

export default StudentPrivateRouter